/**
 * Created by RSchweber-Koren on 1/20/2017.
 */

import angular from "angular";

import Assert from "tbAssert";

import WorkflowError from "../models/errors/WorkflowError";
import TbAppConfigDataServiceModule from "../config/tb-app-config/TbAppConfigDataService";

const mTbServerBaseUrl = new WeakMap();

const mHttpSvc = new WeakMap();
const mLogSvc = new WeakMap();

const preCheckApiCallWorkflowStepName = "EventPreCheckApiCall";

class EventWorkflowPreCheckService {
    constructor($http, $log, TbAppConfigDataService) {
        Assert.StrictAssert($http != null, "Event Workflow Pre-Check Service: Missing or invalid http service dependency");
        Assert.StrictAssert($log != null, "Event Workflow Pre-Check Service: Missing or invalid log service dependency");
        Assert.StrictAssert(TbAppConfigDataService != null, "Event Workflow Pre-Check Service: Missing TrackerBase Application Configuration Data Service Dependency");

        mHttpSvc.set(this, $http);
        mLogSvc.set(this, $log);
        mTbServerBaseUrl.set(this, TbAppConfigDataService.tbServerBaseUrl);
    }

    _buildPreCheckApiUrl(eventId, urlSuffix) {
        return `${mTbServerBaseUrl.get(this)}/api/trackingevents/${eventId}/precheck/${urlSuffix}`;
    }

    preCheckScheduleEvent(trackingEvent) {
        const schedulePreCheckUrlSuffix = "schedules";
        return this._preCheckEvent(trackingEvent.EventId, schedulePreCheckUrlSuffix);
    }

    preCheckReportEvent(trackingEvent) {
        const reportPreCheckUrlSuffix = "reports";
        return this._preCheckEvent(trackingEvent.EventId, reportPreCheckUrlSuffix);
    }

    _preCheckEvent(trackingEventId, urlSuffix) {
        const preCheckApiUrl = this._buildPreCheckApiUrl(trackingEventId, urlSuffix);
        return mHttpSvc.get(this).get(preCheckApiUrl)
            .then((response) => {
                if ((response != null) && (response.data != null)) {
                    let preCheckResponseData = response.data;
                    return {
                        preCheckPassed: preCheckResponseData.PreCheckPassed,
                        preCheckMessages: preCheckResponseData.PreCheckMessages
                    };
                }
                else {
                    throw new WorkflowError({
                        stepName: preCheckApiCallWorkflowStepName,
                        message: "No data received from event pre-check api call",
                        workflowErrorData: response
                    });
                }
            })
            .catch((errorResponse) => {
                if (errorResponse instanceof WorkflowError) { throw errorResponse; } //We've already bundled up the error.
                else if (errorResponse instanceof Error) {
                    // Some other error occurred, potentially while processing the response.
                    throw new WorkflowError({
                        stepName: preCheckApiCallWorkflowStepName,
                        message: errorResponse.message,
                        workflowErrorData: errorResponse
                    });
                }
                else {
                    throw new WorkflowError({
                        stepName: preCheckApiCallWorkflowStepName,
                        message: "An error occurred when we asked the server to pre-check the event",
                        workflowErrorData: errorResponse
                    });
                }
            });
    }
}

EventWorkflowPreCheckService.$inject = [
    "$http",
    "$log",
    "TbAppConfigDataService"
];

export default angular
    .module("trackerbase-app.services.event-workflow-pre-check-service", [
        TbAppConfigDataServiceModule
    ])
    .service("EventWorkflowPreCheckService", EventWorkflowPreCheckService)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/EventWorkflowPreCheckService.js
// module id = CdkA
// module chunks = 1